import cn from 'classnames';
import dmPortalUrl from '@dm-portal/url';
import usersUrl from '@users/url';
import { Tenant } from '@framework/tenant/vo/types/Tenant';
import { LogoCreditFlowResearchStandart } from '@dealroadshow/uikit-logo/CreditFlowResearch/Standart';
import Modal from '@dealroadshow/uikit-modal';
import { buttonStyles } from '@dealroadshow/uikit-button';
import appendConsentParams from '@framework/cookie-consent/appendConsentParams';

import styles from './loginModal.module.scss';

interface IProps {
  title: string,
  tenant?: Tenant,
  features?: string[],
  loginUrl?: string,
  registerUrl?: string,
  usePortal?: boolean,
  children?: React.ReactNode,
  isVisible?: boolean,
  showOverlay?: boolean,
  closeOnEsc?: boolean,
  afterClose?: () => void,
  hideOnOverlayClicked?: boolean,
  showCloseButton?: boolean,
  className?: string,
  titleClassName?: string,
  featuresClassName?: string,
  buttonClassName?: string,
  loginButton?: React.ReactNode,
  isFooterVisible?: boolean,
}

const LoginModal = (props: IProps) => {
  const {
    tenant,
    title,
    loginUrl,
    registerUrl,
    features = [],
    children,
    showOverlay = true,
    isVisible,
    closeOnEsc = false,
    afterClose,
    hideOnOverlayClicked = false,
    showCloseButton = false,
    usePortal = true,
    loginButton: LoginButton,
    isFooterVisible = true,
  } = props;

  const getLoginUrl = () => {
    if (loginUrl) {
      return appendConsentParams(loginUrl);
    }

    return appendConsentParams(usersUrl.getLoginUrl(dmPortalUrl.getUrl(`/${ tenant }`), tenant));
  };

  const getRegisterUrl = () => {
    if (registerUrl) {
      return registerUrl;
    }

    return usersUrl.getRegisterUrl(usersUrl.getBaseUrl(), tenant);
  };

  const modalFooter = (
    <div className={ styles.footer }>
      <span>Need an account?</span>
      <a
        className={ styles.registerBtn }
        href={ getRegisterUrl() }
      >
        Register now
      </a>
    </div>
  );

  const featureList = features.map((feature, i) => (
    // eslint-disable-next-line react/no-array-index-key
    <li key={ i } className={ styles.feature }>
      { feature }
    </li>
  ));

  return (
    <Modal
      showOverlay={ showOverlay }
      isVisible={ isVisible }
      className={ cn(styles.loginModal, props.className) }
      closeOnEsc={ closeOnEsc }
      afterClose={ afterClose }
      hideOnOverlayClicked={ hideOnOverlayClicked }
      showCloseButton={ showCloseButton }
      footer={ isFooterVisible && modalFooter }
      usePortal={ usePortal }
      dataTest="landingLoginModal"
    >
      <div className={ styles.logo }>
        <LogoCreditFlowResearchStandart />
      </div>
      <div className={ cn(styles.title, props.titleClassName) }>{ title }</div>

      <ul className={ cn(styles.features, props.featuresClassName) }>
        { featureList }
      </ul>

      { children }

      { LoginButton || (
        <a
          className={ cn(buttonStyles.firm, styles.loginBtn, props.buttonClassName) }
          href={ getLoginUrl() }
        >
          Log in with CreditFlow
        </a>
      ) }
    </Modal>
  );
};

export default LoginModal;
